/**
 * What a menu is made of.
 *
 * Kept apart from the menus themselves because both halves of the catalogue -- the general
 * menus and the musical ones -- need these types, and a shared file is how they have them
 * without importing each other in a circle.
 */

/** One thing a menu can do. */
export interface MenuAction {
  readonly label: string;
  /** The keystroke that does the same thing, written the way a menu writes it. */
  readonly hint?: string;
  readonly disabled?: boolean;
  /** Shown with a tick: the item is a setting rather than a verb. */
  readonly checked?: boolean;
  run(): void;
}

/** A rule between groups of items. */
export interface MenuRule {
  readonly separator: true;
}

export type MenuEntry = MenuAction | MenuRule;

export interface Menu {
  readonly title: string;
  readonly items: readonly MenuEntry[];
}

export const RULE: MenuRule = { separator: true };

export function isRule(entry: MenuEntry): entry is MenuRule {
  return "separator" in entry;
}
